import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-purple-700)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M4 16L4.5 13L20 13L19.5 16L4 16Z" fill={textColor} />
    <path d="M15 4H18L16 20H13L15 4Z" fill={textColor} />
    <path d="M8 4H11L9 20H6L8 4Z" fill={textColor} />
    <path d="M4 11L4.5 8L20 8L19.5 11L4 11Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M7.67993 20.96L8.1348 17.12L23.6799 17.12L23.2253 20.96L7.67993 20.96Z"
      fill={textColor}
    />
    <path
      d="M18.3522 7.68018H22.08L20.2077 24.3202H16.48L18.3522 7.68018Z"
      fill={textColor}
    />
    <path
      d="M11.746 7.68018H15.3599L13.5339 24.3202H9.91992L11.746 7.68018Z"
      fill={textColor}
    />
    <path
      d="M8.32007 14.8799L8.77471 11.1999L24.3201 11.1999L23.8652 14.8799L8.32007 14.8799Z"
      fill={textColor}
    />
  </>
);

export const NumberIcon = createSlideIcon(Icon24x24, Icon32x32);
